export const GUEST_MESSAGE_LIMIT = 15;
export const GUEST_BANNER_LOW_THRESHOLD = GUEST_MESSAGE_LIMIT - 5;

// Local date parts, not toISOString — that returns UTC, so through British
// Summer Time the tally rolled over an hour before the server's day did and
// the banner disagreed with the real allowance for that hour.
const todayKey = () => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
};

export const readGuestMessageCount = () => {
  if (localStorage.getItem("guestMessageCountDate") !== todayKey()) return 0;
  return Number(localStorage.getItem("guestMessageCount") || 0);
};

export const bumpGuestMessageCount = () => {
  const next = readGuestMessageCount() + 1;
  localStorage.setItem("guestMessageCount", String(next));
  localStorage.setItem("guestMessageCountDate", todayKey());
  return next;
};

export const clearGuestMessageCount = () => {
  localStorage.removeItem("guestMessageCount");
  localStorage.removeItem("guestMessageCountDate");
};
